export default "__VITE_ASSET__CweR6gJS__"